import { useCallback, useMemo } from 'react';
import { useCurrentUserProfile } from 'src/graphql/entities/platform-user';
import {
  useCreateUserSettingValue,
  UserSettingId,
  useUpdateUserSettingValue,
} from 'src/graphql/entities/user-setting-value';

export function useAISummaryVisibility() {
  const { user } = useCurrentUserProfile();

  const currentVisibility = useMemo(
    () => user?.userSettingValueMap.get(UserSettingId.AiSummaryVisibility),
    [user?.userSettingValueMap],
  );

  const { createUserSettingValue } = useCreateUserSettingValue();
  const { updateUserSettingValue } = useUpdateUserSettingValue();

  const changeAISummaryVisibility = useCallback(
    (isVisible: boolean) => {
      const value = isVisible ? 'true' : 'false';
      if (currentVisibility) {
        updateUserSettingValue(currentVisibility.userSettingValue, {
          value,
        });
      } else {
        createUserSettingValue({
          userSettingId: UserSettingId.AiSummaryVisibility,
          value,
          valueType: 'boolean',
        });
      }
    },
    [createUserSettingValue, currentVisibility, updateUserSettingValue],
  );

  return useMemo(
    () => ({
      changeAISummaryVisibility,
      currentAISummaryVisibility: !!currentVisibility?.value,
    }),
    [changeAISummaryVisibility, currentVisibility?.value],
  );
}
